<template>
  <div class="dialog-content">
    <div class="recharge-list">
      <div class="amount-rest">
        账户余额<span class="amount-number"
          >￥{{ peerInfo.balance_amount | price }}</span
        >
      </div>
      <div class="operate-tips">请将款项汇入以下银行账户</div>
      <!-- 账户信息复制 -->
      <div class="account-info">
        <div class="account-info-li">
          <div class="account-info-li-label">公司名称：</div>
          <div class="account-info-li-value">
            深圳市六六六国际旅行社有限公司
          </div>
        </div>
        <div class="account-info-li">
          <div class="account-info-li-label">开户银行：</div>
          <div class="account-info-li-value">
            招商银行深圳分行科苑支行
          </div>
        </div>
        <div class="account-info-li">
          <div class="account-info-li-label">汇款帐号：</div>
          <div class="account-info-li-value">
            7559 323 5391 0701
          </div>
        </div>
        <div class="account-copy">
          <div
            class="account-copy-btn"
            :data-clipboard-text="accountInfo"
            @click="copy"
          >
            一键复制
          </div>
        </div>
      </div>

      <!-- 上传凭证 -->
      <div class="upload-voucher-box">
        <div class="require-title">上传汇款回执：</div>
        <div class="require-field">
          <upload-voucher ref="voucherRef" @uploadImage="uploadImage"></upload-voucher>
        </div>
      </div>

      <!-- 对公汇款金额 -->
      <div class="upload-voucher-box public-audit-amount">
        <div class="require-title">汇款金额（元）：</div>
        <div class="require-field">
          <el-input
            type="text"
            :class="{ 'is-error': remitInfo.amount > maxAmount }"
            placeholder="￥ 请输入汇款金额（元）"
            v-model="remitInfo.amount"
            :maxlength="15"
            @keyup.native="validateInput"
          />
          <div class="amount-tips">
            请输入与汇款回执一致的金额以便财务核对，单笔金额不超过 10万
          </div>
        </div>
      </div>

      <div class="public-audit-footer">
        <div class="footer-tips">
          提交成功后，财务人员将在一个工作日内完成审核确认。
        </div>
        <el-button
          type="primary"
          size="large"
          :disabled="
            !remitInfo.voucherUrl ||
              remitInfo.amount == 0 ||
              remitInfo.amount > maxAmount
          "
          @click="submit"
          :loading="submitLoading"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Clipboard from 'clipboard';
import User from '../../libs/user';
import Http from '../../libs/http';
import UploadVoucher from './upload-voucher.vue';

const maxAmount = 100000;

export default {
  components: {
    UploadVoucher,
  },
  props: {
    peerInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      accountInfo:
        '公司名称：深圳市六六六国际旅行社有限公司\n开户银行：招商银行深圳分行科苑支行\n汇款帐号：7559 323 5391 0701',
      remitInfo: {
        voucherUrl: '',
        amount: '',
      },
      submitLoading: false,
      maxAmount,
      showErrorDialog: false,
    };
  },
  watch: {},
  computed: {
    ...mapState('config/', ['recharge_amount']),
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    init() {
      if (!this.show) return;
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX();
        return;
      }
    },

    copy() {
      const clipboard = new Clipboard('.account-copy-btn');
      clipboard.on('success', (e) => {
        this.$message.success('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.$message.success('复制失败');
      });
    },

    uploadImage(url) {
      this.remitInfo.voucherUrl = url;
    },

    validateInput(event) {
      // 获取输入的值
      let value = event.target.value;
      // 使用正则表达式保留数字和小数点部分，允许小数点一次
      const reg = /^[1-9]+\d*\.?(\d{0,2})?|^0?((\.\d{0,2})|\.)?/;
      value = value.match(reg) ? value.match(reg)[0] : '';
      // 更新输入框的值
      this.remitInfo.amount = value;
    },

    async submit() {
      this.submitLoading = true;
      try {
        const res = await Http.post('/visa_peer_corporate_remittance_add', {
          voucher_document_key: this.remitInfo.voucherUrl,
          amount: this.remitInfo.amount * 100,
        });
        this.submitLoading = false;
        this.remitInfo.amount = '';
        this.remitInfo.voucherUrl = '';
        this.$refs.voucherRef.voucher = '';
        if (res.status === 0) {
          this.$emit('close', 'success');
        } else if (res.status === 1) {
          // 重复提交的时候 需要关闭当前的充值弹窗
          this.$emit('close', 'fail');
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>
<style scoped lang="less">
.operate-tips {
  font-weight: 500;
  font-size: 16px;
  color: #2f333d;
}
.account-info {
  width: 400px;
  height: 139px;
  margin: 16px 0 32px;
  padding: 16px;
  background: #f3f6f9;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  .account-info-li {
    display: flex;
    justify-content: flex-start;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    padding-bottom: 8px;
    .account-info-li-label {
      color: #5f666e;
    }
    .account-info-li-value {
      color: #2f333d;
    }
  }
  .account-copy {
    display: flex;
    justify-content: flex-end;
    .account-copy-btn {
      width: 72px;
      height: 24px;
      line-height: 22px;
      border-radius: 1px;
      border: 1px solid #599fff;
      text-align: center;
      font-weight: 400;
      font-size: 12px;
      color: #599fff;
      margin-top: 8px;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }
}

.upload-voucher-box {
  .require-title {
    font-weight: 500;
    font-size: 16px;
    color: #2f333d;
    line-height: 14px;
    margin-bottom: 16px;
    position: relative;
    margin-left: 4px;
    &::before {
      content: "*";
      color: #f4455c;
      position: absolute;
      left: -11px;
      top: -2px;
    }
  }
  .require-field {
    .amount-tips {
      font-weight: 400;
      font-size: 12px;
      color: #91999f;
      margin-top: 8px;
    }
  }
}

.public-audit-amount {
  margin: 32px 0 80px;
  /deep/ .el-input {
    width: 187px;
    height: 40px;
    line-height: 40px;
  }
  /deep/ .is-error .el-input__inner {
    border-color: red;
  }
}

.public-audit-footer {
  width: 100%;
  height: 79px;
  align-items: center;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 24px;
  .footer-tips {
    font-weight: 400;
    font-size: 12px;
    color: #f4455c;
  }
  .submit-btn {
    width: 128px;
    height: 40px;
    line-height: 40px;
    background: #599fff;
    border-radius: 2px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    &:hover {
      cursor: pointer;
      opacity: 0.96;
    }
  }
}

.repeat-warn-dialog{
  z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// src/components/common/public-audit.vue